// extracted by mini-css-extract-plugin
export default {"tableWrapper":"columns-labels-table_tableWrapper__7cqYZ","empty":"columns-labels-table_empty__zDWx7","columnLabelsTable":"columns-labels-table_columnLabelsTable__HOebj"};